'use strict';

import { Cluster } from '../../../app/resources/cluster/cluster.interface';
import * as _ from 'lodash-es';
import { BuildingOptionsAction } from '../../../app/resources/building/building-options/building-options.interface';

(function () {
  angular
    .module('specsguardApp')
    .controller('ProjectAreasCtrl', ProjectAreasCtrl);

  ProjectAreasCtrl.$inject = ['$scope', '$stateParams', '$location', 'Utils', 'Project', 'Auth', 'project',
    'errorMessageService', '$mdDialog', 'AreaDecoratorFactory', 'Labels', 'ProjectDataservice',
    'SimpleDialogFormService', 'ProjectBusinessService', '$injector'];

  function ProjectAreasCtrl($scope, $stateParams, $location, Utils, Project, Auth, project,
    errorMessageService, $mdDialog, AreaDecoratorFactory, Labels, ProjectDataservice,
    SimpleDialogFormService, ProjectBusinessService, $injector) {

    /* ========================================================================
    ==================================== model ================================
    ======================================================================== */

    $scope.LABELS = Labels;
    $scope.clustersAreMoveable = false;

    setTimeout(() => {
      $scope.sg2AuthService = $injector.get('sg2AuthService');
    }, 100);

    //
    // Model
    //

    const canDeleteOpts = {
      accessLevel: null,
      projectLevels: ['manager'],
      project: project
    };

    const canWriteOpts = Object.assign({}, canDeleteOpts, {projectLevels: ['manager', 'contributor']});

    $scope.itemActions = {
      open: function (item) {
        $location.path($location.path() + '/' + item._id);
      },
      editCluster: (item) => $scope.addCluster(null, item),
      removeCluster: (item) => removeCluster(item),
      removeArea: (item) => $scope.removeArea(item),
      copy: (item) => $scope.copyArea(item),
    };

    const initProject = (updatedProj, isInit = false) => {
      const building = findBuilding(updatedProj, $stateParams.building_id);
      building.clusters = building.clusters.filter((cluster) => cluster.active);
      const selectedClusterId = $scope.model ? $scope.model.selectedClusterId : 0;

      $scope.model = {
        project: updatedProj,
        building,
        canWrite: Utils.canWriteProject(Auth.getCurrentUser(), canWriteOpts),
        canDelete: Utils.canWriteProject(Auth.getCurrentUser(), canDeleteOpts),
        dragAndDrop: true,
        selectedClusterId
      };

      decorateModel();
      $scope.filterClusters(selectedClusterId, building);

      if (!isInit) {
        ProjectDataservice.setProjectById(updatedProj._id, updatedProj);
        errorMessageService.showWarning('areaListUpdated2');
      }
    };

    //
    // User interaction
    //
    $scope.enabledDragAndDrop = () => $scope.model.dragAndDrop = true;

    $scope.dragAndDropCallback = (srcList, srcIndex, targetList, targetIndex) => {
      const area = srcList.areas[srcIndex];

      // Remove area from the sourcelist/cluster after update
      updateClustersAfterDrop(srcList, srcIndex, targetList, targetIndex);

      // The targetList/cluster needs to be updated with the new area
      const movedArea = {
        area: area,
        _id: $stateParams.project_id,
        paramId: $stateParams.building_id,
        versionId: project.versionId,
        srcIndex: srcIndex,
        targetIndex: targetIndex,
        clusterId: srcList._id,
        targetClusterId: targetList._id,
      };

      return Project.moveArea(movedArea).$promise.then((updatedProj) => initProject(updatedProj));
    };

    const updateClustersAfterDrop = (srcList, srcIndex, targetList, targetIndex) => {

      // Add the area in the dropped cluster
      targetList.areas.splice(targetIndex, 0, srcList.areas[srcIndex]);

      // Make sure the source (old cluster) doesn't contain the newly moved area
      if (srcList.areas === targetList.areas && targetIndex < srcIndex) {
        srcIndex += 1;
      }

      srcList.areas.splice(srcIndex, 1);
    };

    const removeClusterOptions = {
      title: Labels.getLabel('deletespecificationtitle'),
      content: Labels.getLabel('areyousuredeletespecification') + ' ' + Labels.getLabel('deletespecificationfromdatabase'),
      warning: Labels.getLabel('thisactioncannotbeundone')
    };

    const removeCluster = (cluster) => SimpleDialogFormService.confirm(null, removeClusterOptions).then(() => {
      const body = {
        _id: $stateParams.project_id,
        paramId: $scope.model.building._id,
        versionId: $scope.model.project.versionId,
        cluster: {
          clusterId: cluster._id,
          active: false,
        }
      };
      return Project.editCluster(body).$promise.then(initProject);
    }).catch(() => {
    });

    $scope.submitClusterValue = function (cluster) {
      const saveCluster: any = {cluster: {}};
      Object.assign(saveCluster.cluster, cluster);

      saveCluster._id = $stateParams.project_id;
      saveCluster.versionId = project.versionId;
      saveCluster.cluster.clusterId = cluster._id;

      Project.editCluster(saveCluster);
    };

    /**
     * On receiving function call from outside of this controller.
     *
     * Workaround for $event data getting lost by bindings.
     * The origin of the call is `sgAreaStateClusterTableCtrl`.
     *
     * @param $event Event info, has no further use.
     * @param area The area to update.
     * @param clusterId The id of the cluster containing the area.
     * @param buildingId The id of the building containing the cluster.
     * @param value The new value to set.
     * @param key The property to update.
     */
    $scope.$on('submitAreaValue', ($event, area, clusterId, buildingId, value, key) => {
      $scope.submitAreaValue(area, clusterId, buildingId, value, key);
    });

    /**
     * Upon submitting a new value for an area, from the inline edits in the table.
     *
     * @param area The area to update.
     * @param clusterId The id of the cluster containing the area.
     * @param buildingId The id of the building containing the cluster.
     * @param value The new value to set.
     * @param key The property to update.
     */
    $scope.submitAreaValue = function (area, clusterId, buildingId, value, key): void {
      const saveArea: any = {area: {}};
      Object.assign(saveArea.area, area);

      saveArea._id = $stateParams.project_id;
      saveArea.paramId = buildingId;
      saveArea.versionId = project.versionId;
      saveArea.clusterId = clusterId;
      saveArea.area.areaId = area._id;

      // Update the inline edit form field.
      if (key) {
        saveArea.area[key] = value;
        area[key] = value;
      }

      // For some patches, there's an Angular patch available, use it where possible.
      // Otherwise, just use the legacy API/updater.
      // Note: The $injector is used to load the dependency at runtime instead of init,
      // to prevent load order issues with the datastores.
      switch (key) {
        case 'functionality':
          $injector.get('sg2AreaService').setFunctionality({ ...area, clusterId: clusterId, buildingId: buildingId }, value);
          break;
        case 'surface':
          $injector.get('sg2AreaService').setSurface({ ...area, clusterId: clusterId, buildingId: buildingId }, value);
          break;
        case 'quantity':
          $injector.get('sg2AreaService').setQuantity({ ...area, clusterId: clusterId, buildingId: buildingId }, value);
          break;
        default:
          return Project.editArea(saveArea).$promise.then((updatedProj) => {
            initProject(updatedProj);
            return Promise.resolve(updatedProj);
          });
      }

      Utils.decorate(saveArea.area, 'getAreaTotalFNO', AreaDecoratorFactory.getAreaTotalFNO);
    };

    /**
     * Update cluster.
     *
     * To patch the local copy of the cluster, the eventListener for 'updateCluster' is used.
     *
     * @param cluster The cluster which is updated (both pristine and patched are valid).
     */
    $scope.updateCluster = <Key extends keyof Cluster>(cluster: Cluster, key: Key, value: Cluster[Key]): void => {
      const updatedCluster = {
        ...cluster,
        [key]: value
      };

      // Call API.
      Project.editCluster({
        _id: $stateParams.project_id,
        paramId: $scope.model.building._id,
        versionId: $scope.model.project.versionId,
        cluster: { clusterId: cluster._id, [key]: value }
      }).$promise.then(() => {
        $scope.$emit('updateCluster', updatedCluster);
      });
    };

    /**
     * On updating cluster in another controller.
     *
     * When the cluster is updated somehwere, catch the changes and refresh the controller model,
     * so the changes can be applied to the template in real time.
     *
     * Note that there are two instances of the cluster available in this controller: the default
     * clusters, and a *filteredClusters*, which have a lot of extra properties. They are both patched:
     * - `cluster`: Fully replace the cluster with the updated cluster.
     * - `filteredCluster`: Only replace the cluster properties, but keep all the extra properties.
     *
     * @param $event Broadcast event.
     * @param cluster The updated cluster.
     */
    $scope.$on('updateCluster', ($event, cluster) => {
      const clusterIndex = $scope.model.building.clusters.findIndex(c => c._id === cluster._id);
      $scope.model.building.clusters[clusterIndex] = cluster;

      const filteredClusterIndex = $scope.model.filteredClusters.findIndex(c => c._id === cluster._id);
      $scope.model.filteredClusters[filteredClusterIndex] = {
        ...$scope.model.filteredClusters[filteredClusterIndex],
        ...cluster
      };
    });

    $scope.updateBuilding = (building, key, value) => {
      Project.editBuilding({
        _id: $stateParams.project_id,
        versionId: $scope.model.project.versionId,
        building: {
          buildingId: building._id,
          [key]: value
        }
      }).$promise.then((updatedProj) => {
        initProject(updatedProj);
        return Promise.resolve(updatedProj);
      });
    };

    $scope.selectArea = (cluster, area) => {
      $scope.selectedClusterId = cluster._id;
      area.selected = !area.selected;
    };

    $scope.addCluster = (ev, cluster) => {
      $mdDialog.show({
        controller: 'AddClusterController',
        templateUrl: 'app-legacy/project/areas/add-cluster/add.cluster.html',
        locals: {
          building: $scope.model.building,
          versionId: $scope.model.project.versionId,
          model: cluster ? Object.assign({}, cluster, {edit: true}) : {},
          updateProject: initProject,
        },
        targetEvent: ev
      }).then((updatedProject) => {
        if (updatedProject) {
          initProject(updatedProject);
        }
      }).catch(() => {
      });
    };

    // Show dialog when creating a new area
    $scope.addArea = (ev, clusterShortCode) => {
      $mdDialog.show({
        scope: $scope.$new(),
        preserveScope: false,
        controller: 'AddNewAreaCtrl',
        controllerAs: 'newAreaCtrl',
        locals: {
          hideOverride: false,
          project: $scope.model.project,
          shortCode: clusterShortCode,
          element: {
            isCustom: true,
            hasInputInstruction: false,
          },
        },
        templateUrl: 'app-legacy/project/areas/add-area/add-area-dialog.tmpl.html',
        targetEvent: ev
      }).then((obj) => {
        if (obj.updatedProject) {
          initProject(obj.updatedProject);
        }
        if (obj.redirectUrl) {
          $location.path(obj.redirectUrl);
        }
      }).catch(() => {
      });
    };

    $scope.removeArea = function (area, cluster, buildingId) {

      const saveArea: any = {area: {}};

      saveArea._id = $stateParams.project_id;
      saveArea.paramId = buildingId;
      saveArea.versionId = project.versionId;
      saveArea.clusterId = cluster._id;
      saveArea.area.areaId = area._id;

      saveArea.area.active = false;
      area.active = false;

      Project.editArea(saveArea).$promise
        .then((updatedProj) => initProject(updatedProj));

    };
    /**
     * the copyArea only send the area, building & cluster id.
     */
    $scope.copyArea = (item: any) => {
      const { area, cluster } = item;

      const copyArea: any = {area: {}};

      copyArea._id = $stateParams.project_id;
      copyArea.paramId = $stateParams.building_id;
      copyArea.buildingId = $stateParams.building_id;
      copyArea.area.areaId = area._id;
      copyArea.area.name = `${area.name} (${$scope.LABELS.getLabel('copy2')})`; // add (copy) to the area title
      copyArea.clusterId = cluster._id;

      // Add the API call here
    };

    $scope.removeMultipleAreas = (cluster, buildingId) => {
      cluster.areas
        .filter((area) => area.selected)
        .forEach((area) => $scope.removeArea(area, cluster, buildingId));
    };

    $scope.removeCluster = function (cluster, buildingId) {
      const saveCluster: any = {cluster: {}};

      saveCluster._id = $stateParams.project_id;
      saveCluster.paramId = buildingId;
      saveCluster.versionId = project.versionId;

      saveCluster.cluster.clusterId = cluster._id;
      saveCluster.cluster.name = cluster.name;
      saveCluster.cluster.shortCode = cluster.shortCode;
      saveCluster.cluster.active = false;

      cluster.active = false;

      Project.editCluster(saveCluster).$promise
        .then((updatedProj) => initProject(updatedProj));
    };

    $scope.doItemActionFor = function (item, action) {
      if (!_.isEmpty(item) && !_.isEmpty(action) && angular.isDefined($scope.itemActions[action])) {
        $scope.itemActions[action](item);
      }
    };

    $scope.filterClusters = (clusterId, building) => {
      $scope.model.filteredClusters = building.clusters.filter((cluster) => {
        if (!clusterId) {
          return cluster.active;
        }
        return cluster.active && cluster._id === clusterId;
      });

      // When clusters are filtered, you shouldn't be able to drag&drop
      disableDragAndDrop();
    };


    /**
     * activate the cluster movements
     */
    $scope.moveClusters = () => {
      $scope.clustersAreMoveable = !$scope.clustersAreMoveable;
    };

    /**
     * Initialize the order change
     */
    $scope.orderCluster = (cluster, direction) => {

      const params = {
        _id: $scope.model.project._id,
        id: cluster._id,
        projectId: $scope.model.project._id,
        paramId: $scope.model.building._id,
        buildingId: $scope.model.building._id,
        versionId: $scope.model.project.versionId,
        sourceIndex: getArrayIndex(cluster),
        targetIndex: targetClusterIndex(direction, {id: cluster._id, index: getArrayIndex(cluster)}), // return index of target
        target: {
          id: $scope.model.filteredClusters[targetClusterIndex(direction, { id: cluster._id, index: getArrayIndex(cluster)})]._id,
          position: direction,
        }
      };

      // Reorder the filtered clusters
      Project.moveCluster(params).$promise.then((resp) => {
        $scope.model.filteredClusters = sortArray(
          $scope.model.filteredClusters,
          params['sourceIndex'],
          params['targetIndex']
        );
      });

    };

    /**
     * On new Building Options menu action.
     *
     * Adds backwards compatibilty to the Angular building options menu.
     *
     * @param action The action dispatched from the options menu.
     */
    $scope.sg2BuildingOptionsAction = (action: BuildingOptionsAction) => {
      switch (action.action) {
        case 'changeOrder':
          $scope.moveClusters();
          break;
      }
    };


    //
    // Helpers
    //

    // Helper to get the index of the selected cluster
    const getArrayIndex = (selectedCluster) => $scope.model.filteredClusters.findIndex((clst) => clst._id === selectedCluster._id);

    /**
     * clusterPosition
     *
     * get the cluster target position based on the direction and current
     */
    const targetClusterIndex = (direction: string, obj: any) => {
      const { id, index} = obj;

      const position = {
        above: () => {
          return index > 0 ? index - 1 : index;
        },
        below: () => {
          return index < $scope.model.filteredClusters.length ? index + 1 : index;
        },
        top: () => {
          return 0;
        },
        bottom: () => {
          return $scope.model.filteredClusters.length - 1;
        },
      };

      return position[direction]();

    };

    const sortArray = (arr, oIndex, nIndex) =>  {
      while (oIndex < 0) {
        oIndex += arr.length;
      }
      while (nIndex < 0) {
        nIndex += arr.length;
      }
      if (nIndex >= arr.length) {
        let indx = nIndex - arr.length;
        while ((indx--) + 1) {
          arr.push(undefined);
        }
      }
      arr.splice(nIndex, 0, arr.splice(oIndex, 1)[0]);
      return arr;
    };

    const disableDragAndDrop = () => {
      if ($scope.model.filteredClusters.length < 1) {
        $scope.model.dragAndDrop = false;
      }
    };

    const findBuilding = (proj = $scope.model.project, id) =>
      proj.buildings.find((building) =>
        building._id.toString() === id.toString());

    // $scope.getSelectedAreas = (cluster) => cluster.areas.filter((area) => area.selected);

    /* ========================================================================
    ================================= decorators ==============================
    ======================================================================== */

    // decorate data model
    const decorateModel = () => {
      AreaDecoratorFactory.decorateClustersAndAreas($scope.model.building.clusters, project);
    };

    initProject(project, true);

    // New default action is to have DnD enabled
    $scope.enabledDragAndDrop();

  }
})();
